/// <reference path="DOMAttached.js" />

class PostingRating extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.btn = this.el.querySelector('span');
		this.count = this.el.querySelector('.count');
		this.safeObserve(this.btn, 'click', this.onClick.bind(this));
		this.disableRating = false;
	}

	onClick(ev) {
		this.rate();
		ev.stop;
	}

	rate() {
		if (this.disableRating)
			return;

		this.disableRating = true;

		axios(this.options.rateUrl, {
			method: 'get'
		}).then((response) => {
			this.ratingSuccess();
		});
	}

	ratingSuccess() {
		this.disableRating = false;

		this.count.innerHTML = parseInt(this.count.innerHTML + 1);
		this.stopObserve(this.btn, 'click');
		this.btn.classList.remove('link');
		this.btn.querySelector('img').setAttribute('title', this.options.ratedTooltip);
	}
}
